/*******************************************************************************
  SelectSite.js

  Author: Advait

*******************************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { selectSite } from "../store/siteSlice";
import SelectSiteSimple from "../components/SelectSiteSimple";
import SelectTenant from "./SelectTenant";
import ScheduleItemTable from "../components/ScheduleItemTable";
import RobotCurrentMode from "../components/RobotCurrentMode";
import ShowRounds from "../components/ShowRounds";
import SiteConfigSection from "../components/SiteConfigSection";
import LocationBehavior from "../components/LocationBehavior";
import AdditionalRoundSettings from "./AdditionalRoundSettings";

import "../index.css";

function SelectSite({ pageType, scheduleType }) {
  const isSysAdmin = useSelector((state) => state.user.sysAdmin);
  const selectedTenantId = useSelector((state) => state.selectedSite.tenantId);
  const tenantList = useSelector((state) => state.tenantList.tenants);
  const selectedSiteId = useSelector((state) => state.selectedSite.siteId);
  const selectedSite = useSelector(selectSite);
  const companyName = tenantList.find((t) => t.id === selectedTenantId)?.company ?? "";

  //***************************************************************************
  // render the UI
  //***************************************************************************
  const restrict_ui = (selectedSite && selectedSite.restrict_ui_page) || {};

  return (
    <div>
      {/**Enhancements - update the condition so that non sysadmin will not see Tenant selection at all
        as of now it appears for a second*/}
      {isSysAdmin || !selectedTenantId ? <SelectTenant /> : null}

      {selectedTenantId ? <SelectSiteSimple /> : null}

      {/** Show following tabs if the select site is called from any of the round config page
            Round config pages - Site Inspection Config, Site Security Patrol Config or Receptionist
          */}
      {selectedSiteId && pageType === "roundConfig" ? (
        <RobotCurrentMode key={"mode-" + selectedSiteId} scheduleType={scheduleType} />
      ) : null}

      {/*** Show Security Patrol Config Page Elements ***/}
      {selectedSiteId &&
      pageType === "roundConfig" &&
      scheduleType === "security_patrol" &&
      !restrict_ui.security_patrol ? (
        <>
          <ScheduleItemTable scheduleType={scheduleType} />
          <LocationBehavior key={"locbehav-" + selectedSiteId} />
          <AdditionalRoundSettings
            key={"addSetting-" + selectedSiteId}
            scheduleType={scheduleType}
          />
        </>
      ) : null}

      {/*** Show Inspection Config Page Elements ***/}
      {selectedSiteId &&
      pageType === "roundConfig" &&
      scheduleType === "inspection" &&
      !restrict_ui.inspection ? (
        <>
          <ScheduleItemTable scheduleType={scheduleType} />
          <AdditionalRoundSettings
            key={"addSetting-" + selectedSiteId}
            scheduleType={scheduleType}
          />
        </>
      ) : null}

      {/*** Show Reception Config Page Elements ***/}
      {selectedSiteId &&
      pageType === "roundConfig" &&
      scheduleType === "reception" &&
      !restrict_ui.reception ? (
        <ScheduleItemTable scheduleType={scheduleType} />
      ) : null}

      {/*** Show Reporting Page Elements ***/}
      {selectedSiteId && pageType === "reporting" ? (
        <ShowRounds
          restrict_ui={restrict_ui}
          siteid={selectedSiteId}
          sitename={selectedSite.siteName}
          tenantName={companyName}
          hideInspectionPage={restrict_ui.inspection}
          hideSecurityPatrolPage={restrict_ui.security_patrol}
          sysAdmin={isSysAdmin}
        />
      ) : null}
      {/** Show following tabs if the select site is called from System Config page */}
      {selectedSiteId && pageType === "sysConfig" ? <SiteConfigSection /> : null}
    </div>
  );
}
export default SelectSite;
